import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';

export type SubmitWithoutInfoWarningModalProps = {
  updating: boolean;
  onSubmit: (ehrSubmission?: string) => void;
  onClose: () => void;
};

/**
 * A modal that warns the user that they're submitting the task with no info attached.
 */
const SubmitWithoutInfoWarningModal = ({ updating, onSubmit, onClose }: SubmitWithoutInfoWarningModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalTitle>Submit PA without information</ModalTitle>

      <ModalBody>
        <Typography styledAs="bodyDMSans">
          <strong>Important:</strong> Tandem will submit the PA without the information requested. If you are waiting on
          information from the patient or prescriber, please leave the task open until ready to submit.
        </Typography>
      </ModalBody>

      <ModalFooter>
        <Button size="sm" onClick={onClose} disabled={updating} variant="tertiary">
          Back
        </Button>
        <Button size="sm" onClick={() => onSubmit()} isLoading={updating}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubmitWithoutInfoWarningModal;
